function SectionContent({ className, children }) {
    return <div className={className ? "section-content " + className : "section-content"}>
        {children}
    </div>;
}

export default SectionContent;